import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sliceKey as name } from './utils';
import {
	getNetworkState,
	NetworkError,
	networkInitialState,
	NetworkStatuses,
} from '../../../store/network';
import { InstoreServiceGroup, InstoreServiceState } from './types';

const initialState: InstoreServiceState = {
	services: [],
	serviceNetwork: networkInitialState,
};

const InstoreServiceSlice = createSlice({
	name,
	initialState,
	reducers: {
		fetchServicesRequest(state) {
			state.serviceNetwork = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchServicesSuccess(state, action: PayloadAction<{ data: InstoreServiceGroup[] }>) {
			const { data } = action.payload;
			state.services = data;
			state.serviceNetwork = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchServicesFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.serviceNetwork = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const {
	actions: instoreServiceActions,
	reducer: instoreServiceReducer,
	name: instoreServiceName,
} = InstoreServiceSlice;

export const InstoreServiceInitialState = initialState;
